import { useCallback, useEffect } from "react";
import wkx from "wkx";
import * as L from "leaflet";
import { GeoJsonObject } from "geojson";

import { useRegularGrid } from "src/hooks";
import { useCase } from "src/hooks/useCase";

interface Props {
  map: L.Map;
  caseId: string | number;
  opacity: number;
  pane: string;
}

export function CaseBufferOnMap(props: Props) {
  const { map } = props;
  const { data: acase } = useCase(props.caseId);
  const featureGroup = L.featureGroup();

  /**
   * Callbacks
   */
  const renderCaseBufferCallback = useCallback(renderCaseBuffer, [featureGroup, props.opacity, props.pane, acase]);

  /**
   * Effects
   */
  useEffect(addFeatureGroupToMap, [featureGroup, map]);
  useEffect(renderCaseBufferCallback, [acase, renderCaseBufferCallback]);

  /**
   * Functions
   */
  function renderCaseBuffer() {
    if (!acase) return;

    const geometry = wkx.Geometry.parse(acase.buffer_frontendSrid).toGeoJSON() as GeoJsonObject;

    const geojsonLayer = L.geoJSON(geometry, {
      pane: props.pane,
      pmIgnore: true,

      style: {
        // @ts-ignore
        color: "#7C6EE6",
        fillColor: "#7C6EE6",
        opacity: props.opacity,
        fillOpacity: 0.2 * (props.opacity !== undefined ? props.opacity : 1),
        interactive: false,
      },
    });

    featureGroup.addLayer(geojsonLayer);
  }

  function addFeatureGroupToMap() {
    featureGroup.addTo(map);
    return function cleanup() {
      featureGroup.removeFrom(map);
    };
  }

  // return nothing because Leaflet.js does the rendering
  return null;
}
